import { observer } from 'mobx-react-lite'
import { useEffect } from 'react'
import { useParams } from 'react-router'
import { useCompliancePageContext } from 'pages/settings/pages/compliance/context'
import { CommonNumbers } from 'pages/settings/pages/compliance/ui/CommonNumbers/CommonNumbers'
import { NextButton } from 'pages/settings/ui/NextButton/NextButton'

export const EditCnamNumbers = observer(() => {
  const { id } = useParams()
  const {
    callingPageStore: {
      editCnamNumbersStore: {
        loading,
        numbersStore,
        isDisabledSubmit,
        updateNumbers,
        setEditingCnamFromId,
      },
    },
  } = useCompliancePageContext()

  useEffect(() => {
    id && setEditingCnamFromId(Number(id))
  }, [])

  return (
    <>
      <CommonNumbers loading={loading} numbersStore={numbersStore} />
      <NextButton text='Save' disabled={isDisabledSubmit} onClick={updateNumbers} />
    </>
  )
})
